import { Block, idGenerator } from './idGenerator.utils';
import { AdInAmpBody } from './ampAdUnits';

export const adBlockType = 'ad';
export const inlineTextBlockType = 'inline-text';

export const getAdsWithIndexes = (body: any, adsInBody: Array<AdInAmpBody>) => {
    let inlineTextBlocksCounter = 0;
    const adsWithIndexes: Array<any> = [];

    body.forEach((block: Block, index: number) => {
      if (block.type === inlineTextBlockType) {
          inlineTextBlocksCounter += 1;
          const adInBody = adsInBody.find(ad => ad.numberOfInlineTextBlocksBeforeAd === inlineTextBlocksCounter);
          if (adInBody) {
              adsWithIndexes.push({
                  adInBody,
                  index,
              });
          }
      }
    });
    return adsWithIndexes;
};

export const addAdsBlocksToBody = (body: Array<Block>, adsInBody: Array<AdInAmpBody>): Array<Block> => {
    const bodyWithAds = [...body];
    const adsWithIndexes = getAdsWithIndexes(body, adsInBody);

    if (adsWithIndexes.length > 0) {
        let adsBlocksCounter = 0;

        adsWithIndexes.forEach(({ adInBody, index }) => {
            const adBlock = {
                type: adBlockType,
                dataId: idGenerator(),
                ...adInBody,
            };
        const adIndex = index + adsBlocksCounter;
        bodyWithAds.splice(adIndex + 1, 0, adBlock);
        adsBlocksCounter += 1;
        });
    }
    return bodyWithAds;
};
